<button type="button" #hackButton class="d-none">
  NÃO REMOVER ESTE BOTÃO!!! Este botão deve existir para fazer com que a caixa
  de seleção de imagens não seja aberta ao clicar em qualquer parte do
  componente.
</button>

<input
  #fileInput
  id="fileInput"
  type="file"
  [accept]="acceptedFileTypes"
  (change)="addFile()"
  style="display: none"
  [disabled]="disabled"
/>

<div
  class="d-flex justify-content-between align-items-center input-field"
  [matTooltip]="disabled ? '' : value.fileName || 'Selecione o arquivo'"
>
  <div
    class="d-flex align-items-center text-truncate cursor-pointer w-100"
    (click)="changeFile($event)"
  >
    <i class="me-2" [class]="getIcon()"></i>

    <span [class.text-muted]="!value.fileName" class="text-truncate">{{
      value.fileName || value.fileId || "Selecionar " + label
    }}</span>
  </div>

  @if (!disabled) {
    <div style="position: relative">
      <button
        type="button"
        class="mat-elevation-z1 mb-0 input-field-button px-3"
        tabindex="-1"
        (click)="changeFile($event)"
      >
        <i class="fas fa-file-plus"></i>
      </button>
      <button
        mat-button
        type="button"
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="menu"
        style="opacity: 0; position: absolute; bottom: 0; right: 0; z-index: -1"
      >
        Menu
      </button>
    </div>
  }
</div>

<mat-menu #menu="matMenu">
  <!-- <button mat-menu-item (click)="openFile()">
  <i class="far fa-sync me-2"></i> Alterar
</button> -->
  <button mat-menu-item (click)="removeFile()">
    <i class="far fa-trash me-2"></i> Remover
  </button>
</mat-menu>
